module.exports = __webpack_public_path__ + "static/media/floral-spring-svgrepo-com.5db1dbdb.svg";